import Vue from 'vue'
import VueRouter from 'vue-router'
import { setSeo } from '@/utils/seo'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        meta: {
            title: 'نتایج زنده فوتبال، جدول لیگ‌ها و آخرین اخبار | ضربه آزاد',
            description: 'نتایج زنده و برنامه مسابقات فوتبال، جدول رده‌بندی لیگ‌های معتبر، ترکیب تیم‌ها و آخرین اخبار لحظه‌ای فوتبال ایران و جهان در ضربه آزاد',
        },
        component: () => import('@/views/HomeView.vue')
    },
    {
        path: '/match/:id',
        name: 'MatchDetail',
        meta: {
            title: 'جزئیات بازی | ضربه آزاد',
            description: 'نتیجه، آمار، رویدادها و اطلاعات بازی فوتبال در ضربه آزاد',
        },
        component: () => import('@/views/MatchDetail.vue')
    },
    {
        path: '/news',
        name: 'NewsPage',
        meta: {
            title: 'آخرین اخبار فوتبال ایران و جهان | ضربه آزاد',
            description: 'تازه‌ترین اخبار فوتبال؛ نقل و انتقالات، ترکیب تیم‌ها، نتایج بازی‌ها و اخبار لیگ‌های اروپا و ایران',
        },
        component: () => import('@/views/NewsPage.vue')
    },
    {
        path: '/matches',
        alias: '/Matches',
        name: 'Matches',
        meta: {
            title: 'برنامه و نتایج زنده مسابقات فوتبال | ضربه آزاد',
            description: 'برنامه مسابقات، نتایج زنده و تاریخ بازی‌های فوتبال لیگ‌های معتبر جهان در ضربه آزاد',
        },
        component: () => import('@/views/Matches.vue')
    },
    {
        path: '/news/:slug',
        name: 'NewsDetail',
        meta: {
            title: 'خبر | ضربه آزاد',
            description: 'گزارش و تحلیل خبر فوتبال در ضربه آزاد',
        },
        component: () => import('@/views/NewsDetail.vue')
    },
    {
        path: '/search',
        name: 'SearchResults',
        meta: {
            title: 'جستجو | ضربه آزاد',
            noindex: true,
        },
        component: () => import('@/views/SearchResults.vue')
    },
    {
        path: '/competition/:id',
        name: 'competition',
        meta: {
            title: 'مسابقات | جدول، برنامه و نتایج | ضربه آزاد',
            description: 'جدول رده‌بندی، برنامه بازی‌ها و آخرین نتایج مسابقات فوتبال در ضربه آزاد',
        },
        component: () => import('@/views/Competition.vue')
    },
    {
        path:'/team/:id',
        name:'team',
        meta: {
            title: 'تیم | ترکیب، بازی‌ها و نتایج | ضربه آزاد',
            description: 'ترکیب کامل تیم، بازی‌های اخیر و پیش رو، جدول لیگ و اخبار مرتبط در ضربه آزاد',
        },
        component:()=>import('@/views/team.vue')
    },
    {
        path: '/player/:slug',
        name: 'PlayerDetail',
        meta: {
            title: 'بازیکن | پروفایل و اخبار | ضربه آزاد',
            description: 'پروفایل بازیکن، تیم، آمار و آخرین اخبار مرتبط در ضربه آزاد',
        },
        component: () => import('@/views/PlayerDetail.vue')
    },
    {
        path: '/coach/:slug',
        name: 'CoachDetail',
        meta: {
            title: 'مربی | پروفایل و اخبار | ضربه آزاد',
            description: 'پروفایل سرمربی، تیم فعلی، بازی‌های اخیر و آخرین اخبار مرتبط در ضربه آزاد',
        },
        component: () => import('@/views/CoachDetail.vue')
    },
    {
        path: '/fifa-day',
        name: 'FifaDay',
        meta: {
            title: 'فیفا دی | برنامه و نتایج بازی‌های تیم‌های ملی | ضربه آزاد',
            description: 'برنامه و نتایج بازی‌های تیم‌های ملی در فیفا دی — مقدماتی جام جهانی، لیگ ملت‌های اروپا و بازی‌های دوستانه با روزشمار فارسی',
        },
        component: () => import('@/views/FifaDayView.vue')
    },
    {
        path: '/special',
        alias: [
            '/special/wrestling',
            '/special/wrestling-world-championships-astana-2026',
            '/wrestling',
            '/wrestling-championships-2026'
        ],
        name: 'SpecialEvents',
        meta: {
            title: 'جدول کشتی و نتایج زنده قهرمانی جهان ۲۰۲۶ | جدول رسیدن تا فینال پهلوانان ایرانی | ضربه آزاد',
            description: 'جدول کشتی مسابقات قهرمانی جهان ۲۰۲۶ آستانه؛ جدول رسیدن تا فینال پهلوانان ایرانی، نتایج زنده اوزان کشتی آزاد و کشتی فرنگی و قرعه هر دور با استعلام مستقیم از UWW در ضربه آزاد',
        },
        component: () => import('@/views/SpecialEvents.vue')
    },
    {
        path: '/special/:slug',
        name: 'SpecialEventDetail',
        meta: {
            title: 'رویداد ویژه | پوشش اختصاصی | ضربه آزاد',
            description: 'پوشش اختصاصی رویداد ورزشی: جدول، بازی‌ها و آخرین اخبار در ضربه آزاد',
        },
        component: () => import('@/views/SpecialEventDetail.vue')
    },
    {
        path: '/compare',
        name: 'TeamCompare',
        meta: {
            title: 'مقایسه دو تیم | آمار رو در رو | ضربه آزاد',
            description: 'دو تیم فوتبال را انتخاب کنید و آمارشان را مقایسه کنید: جایگاه جدول، امتیازات، فرم اخیر، بهترین گلزنان و پاسورها و رویارویی‌های مستقیم در ضربه آزاد',
        },
        component: () => import('@/views/TeamCompare.vue')
    },
    {
        path: '/did-you-know',
        name: 'DidYouKnow',
        meta: {
            title: 'دانستنی‌های فوتبالی | ضربه آزاد',
            description: 'دانستنیِ روز فوتبال — هر روز یک مطلب کامل با عکس و منبع اصلی؛ رکوردها، تاریخ فوتبال و روایت‌های کمترشنیده در ضربه آزاد',
        },
        component: () => import('@/views/DidYouKnow.vue')
    },
    {
        path: '/did-you-know/:slug',
        name: 'FactDetail',
        meta: {
            title: 'دانستنی فوتبالی | ضربه آزاد',
            description: 'متن کامل دانستنی فوتبالی با عکس، جزئیات و منبع اصلی در ضربه آزاد',
        },
        component: () => import('@/views/FactDetail.vue')
    },
    {
        path: '/contact',
        name: 'Contact',
        meta: {
            title: 'تماس با ما | ضربه آزاد',
            description: 'ایمیل رسمی تماس با ضربه آزاد: hoseinkhodayarian@gmail.com — همکاری و تبلیغات، گزارش خطای آماری و پیشنهاد موضوع برای دانستنی‌های فوتبالی',
        },
        component: () => import('@/views/ContactView.vue')
    },
    {
        path: '/site-health',
        alias: ['/health', '/admin/health'],
        name: 'SiteHealth',
        meta: {
            title: 'داشبورد سلامت سایت و وضعیت ایندکس | ضربه آزاد',
            description: 'داشبورد بررسی سلامت سرور، کدهای وضعیت HTTP، نقشه‌های سایت و وضعیت ایندکس سرچ کنسول ضربه آزاد',
            noindex: true,
        },
        component: () => import('@/views/SiteHealthView.vue')
    },
    {
        // پنل مدیریت — ورود مستقیم با URL؛ در robots.txt بسته و noindex
        // (سمت سرور هم برای ربات‌ها noindex می‌شود — genericFor)
        path: '/admin',
        name: 'Admin',
        meta: {
            title: 'پنل مدیریت | ضربه آزاد',
            noindex: true,
        },
        component: () => import('@/views/AdminPage.vue')
    },
    {
        path: '/videos',
        name: 'Videos',
        meta: {
            title: 'آرشیو ویدئوهای ورزشی | کشتی و فوتبال | ضربه آزاد',
            description: 'آرشیو ویدئو و کلیپ‌های ورزشی مسابقات کشتی و فوتبال از منابع رسمی — پخش مستقیم و سبک در ضربه آزاد',
        },
        component: () => import('@/views/VideosPage.vue')
    },
    {
        path: '/videos/page/:page',
        name: 'VideosPageN',
        meta: {
            title: 'آرشیو ویدئوهای ورزشی | ضربه آزاد',
            description: 'صفحه‌بندی آرشیو ویدئوهای ورزشی ضربه آزاد',
        },
        component: () => import('@/views/VideosPage.vue')
    },
    {
        path: '/videos/tag/:tag',
        name: 'VideosTag',
        meta: {
            title: 'ویدئوها بر اساس برچسب | ضربه آزاد',
            description: 'ویدئوهای ورزشی بر اساس برچسب — کشتی و فوتبال در ضربه آزاد',
        },
        component: () => import('@/views/VideosPage.vue')
    },
    {
        path: '/videos/tag/:tag/page/:page',
        name: 'VideosTagPageN',
        meta: {
            title: 'ویدئوها بر اساس برچسب | ضربه آزاد',
            description: 'ویدئوهای ورزشی بر اساس برچسب — کشتی و فوتبال در ضربه آزاد',
        },
        component: () => import('@/views/VideosPage.vue')
    },
    {
        path: '/video/:slug',
        name: 'VideoDetail',
        meta: {
            title: 'ویدئو ورزشی | ضربه آزاد',
            description: 'تماشای ویدئو ورزشی — کلیپ‌های مسابقات کشتی و فوتبال در ضربه آزاد',
        },
        component: () => import('@/views/VideoDetail.vue')
    }
]

const index = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior() {
        return { x: 0, y: 0 }
    }
})

// متای پیش‌فرض هر مسیر — ویوها بعد از گرفتن داده با setSeo بازنویسی می‌کنند
index.afterEach((to) => {
    const m = to.meta || {}
    setSeo({
        title: m.title,
        description: m.description,
        path: to.path,
        noindex: m.noindex,
    })
})

// URLهای قدیمی چندسگمنتی خبر (اسلاگ‌های حاوی «/» مثل «129973-عنوان/-ادامه»)
// با /news/:slug مچ نمی‌شوند → NewsDetail اصلاً مونت نمی‌شد. گارد آن‌ها را
// به /news/<id>/ جمع می‌کند تا ویو با id لود کند و بعد به slug رسمی replace کند.
// (سمت سرور هم ۳۰۱ داریم؛ این لایهٔ دوم برای محیط‌های بدون هندلر سرور است)
index.beforeEach((to, from, next) => {
    if (to.matched.length) return next()
    const m = to.path.match(/^\/news\/(\d+)/)
    if (m) return next({ path: '/news/' + m[1] + '/', replace: true })
    next()
})

export default index
